import { render, staticRenderFns } from "./GGModal.vue?vue&type=template&id=601780f1&"
import script from "./GGModal.vue?vue&type=script&lang=js&"
export * from "./GGModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('601780f1')) {
      api.createRecord('601780f1', component.options)
    } else {
      api.reload('601780f1', component.options)
    }
    module.hot.accept("./GGModal.vue?vue&type=template&id=601780f1&", function () {
      api.rerender('601780f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/GGModal.vue"
export default component.exports